import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

export const UiSuspensefulOutlet: React.FC = () => (
    <Suspense>
        <Outlet />
    </Suspense>
);
